import { Context } from '@nuxt/types'
import {
  loopingVaultSermonID,
  promoVideoID,
  topVideoID,
} from '~/assets/ts/utils/overview'

export default async function ({ store }: Context) {
  await store.dispatch('sermons/fetchSermons', {
    sermonIDs: [topVideoID, loopingVaultSermonID, promoVideoID],
    lite: false,
    liteBroadcaster: false,
    cache: false,
  })
}
